export default __webpack_public_path__ + "f337f3ecdb15a231941a5c1f8c814e53.png";